import { defineMessages } from "react-intl"

export default defineMessages({
  headerUplay: {
    id: "app.pages.profile.PersonalInformation.headerUplay",
  },
  name: {
    id: "app.pages.profile.PersonalInformation.name",
  },
  email: {
    id: "app.pages.profile.PersonalInformation.email",
  },
  username: {
    id: "app.pages.profile.PersonalInformation.username",
  },
  age: {
    id: "app.pages.profile.PersonalInformation.age",
  },
  editUplayProfileDesc1: {
    id: "app.pages.profile.PersonalInformation.editUplayProfileDesc1",
  },
  editUplayProfileDesc2: {
    id: "app.pages.profile.PersonalInformation.editUplayProfileDesc2",
  },
  ubiAccountReload: {
    id: "app.pages.profile.PersonalInformation.ubiAccountNameReload"
  }
})
